import countries from 'i18n-iso-countries';
import english from 'i18n-iso-countries/langs/en.json';

/**
 * Country codes into what a person recognises (P11.11): a flag and a name.
 *
 * The flag is the two regional-indicator letters of the ISO code, which a browser
 * draws as a flag where its system fonts have them. Windows has none, so the code is
 * always written beside it rather than leaving a bare pair of letters to decode.
 */

countries.registerLocale(english);

/** `GB` → 🇬🇧. Anything that is not two letters comes back empty. */
export function flagOf(code: string): string {
  if (!/^[A-Za-z]{2}$/.test(code)) return '';
  const upper = code.toUpperCase();
  return String.fromCodePoint(
    0x1f1e6 + upper.charCodeAt(0) - 65,
    0x1f1e6 + upper.charCodeAt(1) - 65,
  );
}

/** Where the library's short ("alias") name is wrong or too clipped to read. */
const SHORT_NAMES: Readonly<Record<string, string>> = {
  GB: 'United Kingdom',
  KR: 'South Korea',
  KP: 'North Korea',
  IR: 'Iran',
  SY: 'Syria',
  VE: 'Venezuela',
  BO: 'Bolivia',
  TZ: 'Tanzania',
  MD: 'Moldova',
  LA: 'Laos',
  RU: 'Russia',
};

/** `GB` → United Kingdom, `CN` → China; an unknown code is returned as it came. */
export function countryName(code: string): string {
  const upper = code.toUpperCase();
  return SHORT_NAMES[upper] ?? countries.getName(upper, 'en', { select: 'alias' }) ?? code;
}

/** The map's shapes carry ISO numeric ids ("826"); the API speaks alpha-2. */
export function alpha2OfNumeric(id: string | number): string | undefined {
  return countries.numericToAlpha2(String(id).padStart(3, '0'));
}
